import { PricingProfileAddPanel } from "@/components/organisms";

export const PricingProfileAdd = () => (
  <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
    <PricingProfileAddPanel />
  </div>
);